export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/chevron-right-white.png?56e86e127cf2dd6457b56e621ab05124";